
    
    import { createRequest, createActionRequest } from '/home/runner/_work/fe-roaming/fe-roaming/main/node_modules/.pnpm/@modern-js+plugin-data-loader@3.1.4_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@modern-js/plugin-data-loader/dist/esm/cli/createRequest';
  
    
      export const loader = createRequest('(country)/page');
    
  